export default __webpack_public_path__ + "static/media/b2.590020c1.jpg";